var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2057_17350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0585938,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2057_17350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.3086H9.75V9.80859H11.25V8.30859H9.75V6.80859H8.25V8.30859H6.75V9.80859H8.25V11.3086ZM3 14.3086V12.8086H4.5V7.55859C4.5 6.52109 4.8125 5.59922 5.4375 4.79297C6.0625 3.98672 6.875 3.45859 7.875 3.20859V2.68359C7.875 2.37109 7.98438 2.10547 8.20312 1.88672C8.42188 1.66797 8.6875 1.55859 9 1.55859C9.3125 1.55859 9.57812 1.66797 9.79688 1.88672C10.0156 2.10547 10.125 2.37109 10.125 2.68359V3.20859C11.125 3.45859 11.9375 3.98672 12.5625 4.79297C13.1875 5.59922 13.5 6.52109 13.5 7.55859V12.8086H15V14.3086H3ZM9 16.5586C8.5875 16.5586 8.23438 16.4117 7.94063 16.118C7.64687 15.8242 7.5 15.4711 7.5 15.0586H10.5C10.5 15.4711 10.3531 15.8242 10.0594 16.118C9.76563 16.4117 9.4125 16.5586 9 16.5586ZM6 12.8086H12V7.55859C12 6.73359 11.7063 6.02734 11.1187 5.43984C10.5312 4.85234 9.825 4.55859 9 4.55859C8.175 4.55859 7.46875 4.85234 6.88125 5.43984C6.29375 6.02734 6 6.73359 6 7.55859V12.8086Z",
    fill: "url(#paint0_linear_2057_17350)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2057_17350",
    x1: 9,
    y1: 1.55859,
    x2: 9,
    y2: 16.5586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.02a1f2777660bec0bd58f809a4a18431.svg";
export { ForwardRef as ReactComponent };